import { RouteProp } from '@react-navigation/native';
import {
  CardStyleInterpolators,
  StackNavigationOptions
} from '@react-navigation/stack';
import { Platform } from 'react-native';

export const getScreenOptions = (route: RouteProp<any>) => {
  const paramString: string = JSON.stringify(route.params);
  let screenOptions: StackNavigationOptions = {
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS
  };
  if (typeof route.params !== 'undefined') {
    if (
      JSON.parse(paramString)['params'] &&
      JSON.parse(paramString)['params']['backAnimation'] &&
      JSON.parse(paramString)['params']['backAnimation'] === true
    ) {
      if (Platform.OS === 'android' || Platform.OS === 'web') {
        screenOptions = {
          headerShown: false,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          animationTypeForReplace: 'pop'
        };
      } else {
        screenOptions = {
          headerShown: false,
          animationTypeForReplace: 'pop'
        };
      }
    }
  }
  return screenOptions;
};
